/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Audiences_DetailInputs */

const en_common_header_explore_audiences_detail = /** @type {(inputs: Common_Header_Explore_Audiences_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools for your role`)
};

const zh_common_header_explore_audiences_detail = /** @type {(inputs: Common_Header_Explore_Audiences_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为你的角色找工具`)
};

/**
* | output |
* | --- |
* | "Tools for your role" |
*
* @param {Common_Header_Explore_Audiences_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_audiences_detail = /** @type {((inputs?: Common_Header_Explore_Audiences_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Audiences_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_audiences_detail(inputs)
	return zh_common_header_explore_audiences_detail(inputs)
});
export { common_header_explore_audiences_detail as "common.header.explore.audiences.detail" }